export interface EmojiIconProps {
  emoji: string;
  className?: string;
  emojiClassName?: string;
  emojiIconSize?: EmojiIconSize;
}

export enum EmojiIconSize {
  SMALL,
  LARGE,
}
